








import { Vue, Component, Prop } from "vue-property-decorator";
import { Activity } from "@/graphql/query/activity/feed";
import { AppAccountLink, RoomLink } from "./helper";

@Component({ components: { AppAccountLink, RoomLink } })
export default class AssignAppAccountLog extends Vue {
  @Prop({ type: Object, required: true }) activity!: Activity;
}
